export const SAVED_PASSENGERS_BOTTOM_SHEET = 'saved-passengers-bottom-sheet';
